import { simpleLookupConfig } from "../../../shared/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineArea";

const url = "/api/machines/MachineArea";

export const machineAreaLookupConfig = simpleLookupConfig({
  name: vsObjectName,
  nameSingular: "Area",
  url,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
